export const GET_ASSESSMENT_WINDOW_ASSIGNMENTS = `
  query getAssessmentWindowAssignments(
    $entityId: ID!
    $entityType: Entity!
    $filter: AssignmentQueryFilter
  ) {
    assignment(
      entityId: $entityId
      entityType: $entityType
      filter: $filter
    ) {
      assignmentCategory
      assignmentId
      assignmentType
      assignmentName
      changedAt
      assignor
      changedBy
      createdAt
      createdBy
      dateFrom
      dateTo
      entityId
      entityType
      grade
      lessonPlanId
      parentId
      resources
      status
      periodId
      tags
    }
  }
`;

const GET_ASSIGNMENTS = `query GetAssignments($entityId: [ID!]!, $entityType: Entity!, $assignmentType: [String]) {
    assignments(
      entityId: $entityId, 
      entityType: $entityType, 
      filter: {
        status: [ASSIGNED, IN_PROGRESS, COMPLETE, DONE],
        assignmentType: $assignmentType
      }
    ) {
      entityId
      assignments {
        assignmentId
        assignmentType
        createdAt
        dateFrom
        dateTo
        entityId
        entityType
        parentId
        status
        lessonPlanId
        manifest {
          activityType
          locale
          sequence
          status
          storyId
          activity {
            activityId
            assignmentId
            displayStatus
            status
            createdAt
            updatedAt
            storyId
            tags
            type
          }
        }
      }
    }
  }`;

export const GET_ASSIGNMENTS_BY_LESSON_IDS = `query getAssignmentsByLessonIds(
  $entityId: ID!
  $entityType: Entity!
  $grade: Grade!
  $dateFrom: String
  $dateTo: String
  $lessonPlanIds: [ID]
) {
  assignment(
    entityId: $entityId
    entityType: $entityType
    filter: {
      grade: $grade
      dateFrom: $dateFrom
      dateTo: $dateTo
      lessonPlanIds: $lessonPlanIds
    }
  ) {
    assignmentCategory
    assignmentId
    assignmentType
    changedAt
    assignor
    changedBy
    createdAt
    createdBy
    dateFrom
    dateTo
    entityId
    entityType
    grade
    lessonPlanId
    parentId
    resources
    status
    periodId
    manifest {
      skills {
        unitName
        skillType
        skillId
        season
        order
        lessonPeriodType
        lessonPeriod
        lessonName
      }
    }
  }
}`;

export const CHECK_FOR_SCHOOL_WINDOWS = `query GetAssignments($entityId: ID!, $dateTo: String, $dateFrom: String) {
    assignment(entityId: $entityId, entityType: SCHOOL, filter:{status: [ASSIGNED, IN_PROGRESS, COMPLETE, DONE], dateTo: $dateTo, dateFrom: $dateFrom, entityType: SCHOOL}) {
      assignmentId
      assignmentType
      status
      createdAt
      dateFrom
      dateTo
      entityId
      entityType
    }
  }`;
export default GET_ASSIGNMENTS;
